import type { useKioskStore } from '@/stores/kiosk-store'

type SessionState = Pick<ReturnType<typeof useKioskStore.getState>, 'step' | 'cart' | 'selectedProduct' | 'editingCartItem' | 'loading' | 'processing' | 'adminOpen' | 'refreshing'>

export function isKioskIdle(state: SessionState): boolean {
  return (
    (state.step === 'attractor' || state.step === 'menuTypeSelect') &&
    state.cart.length === 0 &&
    !state.selectedProduct &&
    !state.editingCartItem &&
    !state.loading &&
    !state.processing &&
    !state.adminOpen &&
    !state.refreshing
  )
}
